"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logoutFromBeijingCa = logoutFromBeijingCa;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.regexp.replace");
var CA_LOGOUT_URL = 'https://am.bjedu.cn/am/UI/Logout';
var LOGOUT_TIMEOUT = 1000;
function logoutFromBeijingCa() {
  var portalOrigin = process.env.VUE_APP_PORTAL_ORIGIN || window.location.origin;
  var portalUrl = "".concat(portalOrigin.replace(/\/+$/, ''), "/");
  var logoutUrl = "".concat(CA_LOGOUT_URL, "?goto=").concat(encodeURIComponent(portalUrl));
  var redirectToPortal = function redirectToPortal() {
    return window.location.replace(portalUrl);
  };
  var logoutRequest = typeof window.fetch === 'function' ? window.fetch(logoutUrl, {
    method: 'GET',
    mode: 'no-cors',
    credentials: 'include',
    cache: 'no-store'
  }).catch(function () {
    return undefined;
  }) : Promise.resolve();
  return Promise.race([logoutRequest, new Promise(function (resolve) {
    return window.setTimeout(resolve, LOGOUT_TIMEOUT);
  })]).then(redirectToPortal);
}